import type { KeyboardEvent } from "react";
import Checkbox from "../../basic/checkbox/Checkbox";
import { checkboxCheckedStyles, ClassActivityCategory } from "../../constants/ClassActivityConstants";

interface ConsentCheckboxProps {
    isChecked: boolean;
    onChange: () => void;
    label: string;
    /** Drives the checked color. Defaults to TEST (orange). */
    classActivityCategory?: ClassActivityCategory;
}

const ConsentCheckbox = (props: ConsentCheckboxProps) => {
    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            props.onChange();
        }
    };

    return (
        <div
            role="checkbox"
            data-testid="class-consent-checkbox"
            aria-checked={props.isChecked}
            aria-label={props.label}
            tabIndex={0}
            className="flex gap-xs items-start cursor-pointer"
            onClick={props.onChange}
            onKeyDown={handleKeyDown}
        >
            <div className="mt-xxs">
                <Checkbox
                    isChecked={props.isChecked}
                    checkedClassName={checkboxCheckedStyles[props.classActivityCategory ?? ClassActivityCategory.TEST]}
                />
            </div>
            <span className="text-l text-p6-grey-dark">{props.label}</span>
        </div>
    );
};

export default ConsentCheckbox;
